import type { SspResponse } from "../../../../../api/frameworksApi";
import {
  FormField,
  FormTextarea,
  Modal,
  ModalFooterButtons,
} from "../../../../components/Modal";

import type { LifecycleAction } from "../../types";
export type { LifecycleAction };

export interface LifecycleTransitionDialogProps {
  open: boolean;
  onClose: () => void;
  handleLifecycleTransition: () => void;
  transitioningLifecycle: boolean;
  transitionTarget: string;
  transitionComment: string;
  setTransitionComment: (v: string) => void;
  currentLifecycleActions: LifecycleAction[];
  sspDetail: SspResponse | null;
}

export function LifecycleTransitionDialog({
  open,
  onClose,
  handleLifecycleTransition,
  transitioningLifecycle,
  transitionTarget,
  transitionComment,
  setTransitionComment,
  currentLifecycleActions,
  sspDetail,
}: LifecycleTransitionDialogProps) {
  const actionLabel =
    currentLifecycleActions.find((a) => a.target === transitionTarget)?.label ||
    "Transition Lifecycle";
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={actionLabel}
      description={`Move SSP to "${transitionTarget.replace(/_/g, " ")}" status`}
      size="sm"
      footer={
        <ModalFooterButtons
          onCancel={onClose}
          onSubmit={handleLifecycleTransition}
          submitLabel={
            transitioningLifecycle
              ? "Processing"
              : `Confirm ${currentLifecycleActions.find((a) => a.target === transitionTarget)?.label || transitionTarget.replace(/_/g, " ")}`
          }
          submitDisabled={transitioningLifecycle}
        />
      }
    >
      <p className="text-sm text-foreground mb-3">
        You are about to change the status of{" "}
        <span className="font-semibold text-foreground">
          "{sspDetail?.title || "SSP"}"
        </span>{" "}
        to{" "}
        <span className="font-semibold text-foreground capitalize">
          {transitionTarget.replace(/_/g, " ")}
        </span>
        .
      </p>
      <FormField label="Comment" hint="Optional reason for this transition">
        <FormTextarea
          placeholder="e.g. All controls reviewed and approved by ISSO"
          value={transitionComment}
          onChange={(v) => setTransitionComment(v)}
          rows={3}
        />
      </FormField>
    </Modal>
  );
}
